export function toggleStringValue(values: string[], value: string, enabled: boolean) {
  if (enabled) {
    return values.includes(value) ? values : [...values, value];
  }

  return values.filter((item) => item !== value);
}

/** LiveRamp segment CPM as received, e.g. `1.5` → `$1.5`. */
export function formatLiverampCpm(value: number | null | undefined) {
  return value === null || value === undefined ? '-' : `$${String(value)}`;
}
